module.exports = "/_next/static/images/kobikicho_menu-99537fd8915365dfef76c504ed1581d2.jpg";